import { render } from "./GroupCallView.vue?vue&type=template&id=cb6abb36&scoped=true"
import script from "./GroupCallView.vue?vue&type=script&lang=js"
export * from "./GroupCallView.vue?vue&type=script&lang=js"

import "./GroupCallView.vue?vue&type=style&index=0&id=cb6abb36&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6abb36"]])

export default __exports__